const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1 31V0.999998H4V1.77532H1.69145V30.2247H4V31H1Z",
  fill: "#1E3F6B",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 7 13)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 7 29)",
  stroke: "#0081CC"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 20 13)",
  stroke: "#0081CC"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.4004 24.8241C22.4004 24.6257 22.4612 24.4529 22.5828 24.3057C22.7108 24.1585 22.8708 24.0593 23.0628 24.0081C23.0884 24.0017 23.13 23.9985 23.1876 23.9985C23.5204 23.9985 23.7636 24.1297 23.9172 24.3921C24.0004 24.5201 24.042 24.6641 24.042 24.8241C24.042 25.0033 23.9876 25.1665 23.8788 25.3137C23.7764 25.4545 23.6356 25.5537 23.4564 25.6113C23.3988 25.6241 23.322 25.6305 23.226 25.6305C23.0212 25.6305 22.8452 25.5697 22.698 25.4481C22.4996 25.2945 22.4004 25.0865 22.4004 24.8241Z",
  fill: "#1E3F6B"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.466 24.8241C25.466 24.6257 25.5268 24.4529 25.6484 24.3057C25.7764 24.1585 25.9364 24.0593 26.1284 24.0081C26.154 24.0017 26.1956 23.9985 26.2532 23.9985C26.586 23.9985 26.8292 24.1297 26.9828 24.3921C27.066 24.5201 27.1076 24.6641 27.1076 24.8241C27.1076 25.0033 27.0532 25.1665 26.9444 25.3137C26.842 25.4545 26.7012 25.5537 26.522 25.6113C26.4644 25.6241 26.3876 25.6305 26.2916 25.6305C26.0868 25.6305 25.9108 25.5697 25.7636 25.4481C25.5652 25.2945 25.466 25.0865 25.466 24.8241Z",
  fill: "#1E3F6B"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28.5316 24.8241C28.5316 24.6257 28.5924 24.4529 28.714 24.3057C28.842 24.1585 29.002 24.0593 29.194 24.0081C29.2196 24.0017 29.2612 23.9985 29.3188 23.9985C29.6516 23.9985 29.8948 24.1297 30.0484 24.3921C30.1316 24.5201 30.1732 24.6641 30.1732 24.8241C30.1732 25.0033 30.1188 25.1665 30.01 25.3137C29.9076 25.4545 29.7668 25.5537 29.5876 25.6113C29.53 25.6241 29.4532 25.6305 29.3572 25.6305C29.1524 25.6305 28.9764 25.5697 28.8292 25.4481C28.6308 25.2945 28.5316 25.0865 28.5316 24.8241Z",
  fill: "#1E3F6B"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M28 1V1.767H30.3086V17H31L31 1H28Z",
  fill: "#1E3F6B",
  stroke: "#1E3F6B",
  strokeWidth: 0.5
});

const SvgEquationMatrix2 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationMatrix2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-matrix-2.f94cdab0.svg";
export { ForwardRef as ReactComponent };